<template>
  <div>
    <b-table
      :items="items"
      :fields="fields"
      :tbody-tr-class="rowClass"
      class="mt-3 package-table"
      responsive
      outlined
    >
      <template #head()="scope">
        <div>{{ $t(scope.label) }}</div>
      </template>
      <template #head(selected)>
        <div>
          <input
            type="checkbox"
            id="checkbox"
            v-model="selectAllCheckBox"
            @change="onChangeSelectAllCheckBox(selectAllCheckBox)"
            :disabled="items.length === 0"
          />
        </div>
      </template>
      <template #cell(selected)="row">
        <input
          type="checkbox"
          id="checkbox"
          v-model="row.item.isSelect"
          @change="onSelectAsset(row.item, row.item.isSelect)"
        />
      </template>
      <template #cell(assetStatus)="row">
        <div v-if="row.item.isDeleted">
          {{ $t('property.asset.statusList.deleted') }}
        </div>
        <div v-else>
          {{ row.item.assetStatus }}
        </div>
      </template>
      <template #cell(assetName)="row">
        {{ row.item.assetName }}
        <div>
          <span
            class="detail-activity hover-action"
            @click="onShowAssetDetail(row.item)"
          >
            <small>{{ $t("common.detail") }}</small>
          </span>
        </div>
      </template>
    </b-table>

    <div class="box-footer clearfix" style="display:contents;">
      <hr />
      <paginator
        :totalItem="paginateData.totalItem"
        :currentPage="paginateData.currentPage"
        :pageSize="paginateData.pageSize"
        :totalPage="paginateData.totalPage"
        @onpaginate="onPagination"
      />
    </div>
    <!--  -->
    <select-multiplate-asset-modal
      ref="selectMultiplateAssetActivityTrackingModal"
      :modalTitle="modalTitle"
      :excludeAssetActivityTracking="true"
      :notiData="notiData"
      :isShowMaintenanceType="isShowMaintenanceType"
      :isShowTitle="isShowTitle"
      :isShowPrice="isShowPrice"
      :isShowDescription="isShowDescription"
      :isAssetTable="isAssetTable"
      @emitAssetSelect="emitAssetSelectFunction"
    />
    <!--  -->
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
    <!--  -->
    <asset-in-activity-detail-modal
      ref="assetInActivityDetailModal"
      :modalTitle="assetInActivityDetailModalTitle"
      />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
import LTEModal from "@/components/LTEModal.vue";
import Paginator from "@/components/CustomPaginator.vue";
import SelectMultiplateAssetModal from "./SelectMultiplateAssetModal";
import AssetInActivityDetailModal from "./AssetInActivityDetailModal"
import XLSX from "xlsx";

export default {
  components: {
    "lte-modal": LTEModal,
    SelectMultiplateAssetModal,
    AssetInActivityDetailModal,
    paginator: Paginator
  },
  data: () => ({
    isLoading: false,
    items: [],
    fields: [
      { key: "selected" },
      {
        key: "nonumber",
        label: "common.nonumber",
        sortable: false,
        class: "text-center"
      },
      {
        key: "assetCode",
        label: "propertyMaintenance.assetCode",
        sortable: false
      },
      {
        key: "assetName",
        label: "property.asset.name",
        sortable: false
      },
      // {
      //   key: "assetLocation",
      //   label: "property.asset.location",
      //   sortable: false
      // },
      {
        key: "seriCode",
        label: "property.asset.seriCode",
        sortable: false
      },
      {
        key: "assetModel",
        label: "property.asset.model",
        sortable: false
      },
      {
        key: "nextMaintainanceDate",
        label: "propertyMaintenance.nextImplementationDate",
        sortable: false
      },
      {
        key: "assetStatus",
        label: "property.asset.status",
        sortable: false
      }
    ],
    assetIds: [],
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    searchData: {
      searchText: null,
      fromDate: null,
      toDate: null
    },
    modalTitle: "",
    //
    selectAllCheckBox: false,
    assetSelectIds: [],
    //
    isModalVisible: false,
    objModal: [
      {
        title: "propertyMaintenance.removeAssetTrackingList.title",
        body: "",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ],
    isAssetTable: false,
    isShowMaintenanceType: true,
    isShowTitle: true,
    isShowPrice: false,
    isShowDescription: true,
    notiData: "",
    //
    maintenanceTypeValue: 1,
    titleData: null,
    priceData: null,
    description: null,
    assetInActivityDetailModalTitle: '',
    exportExcelData: {
      headerList: [
        "propertyMaintenance.assetCode",
        "property.asset.name"
      ],
      dataList: []
    },
  }),
  watch: {
    GET_ACTIVITY_TRACKING_LIST_DATA: function() {
      let paginate = this.GET_ACTIVITY_TRACKING_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.items = [];
      this.selectAllCheckBox = false
      let data = this.GET_ACTIVITY_TRACKING_LIST_DATA.results;
      data.forEach((e, i) => {
        let assetId = e.id;
        let nonumber = i + 1 + (paginate.currentPage - 1) * paginate.pageSize;
        let item = {
          assetId: assetId,
          nonumber: nonumber,
          assetCode: e.code,
          assetName: e.name,
          assetLocation: e.location,
          seriCode: e.seri_code,
          assetModel: e.asset_model,
          nextMaintainanceDate: utils.formatSqlDate(e.next_maintainance_date, null, "DD/MM/YYYY"),
          assetStatus: e.status,
          isSelect: false,
          isDeleted: e.is_deleted
        };
        this.items.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACTIVITY_TRACKING_LIST_DATA"
    ])
  },
  methods: {
    rowClass: function(item, type) {
      if (!item || type !== "row") return;
      if (item.isDeleted) {
        return "asset-is-deleted";
      } else return "";
    },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    emitAssetSelectFunction: function(data) {
      let objKey = Object.keys(data);
      if (objKey.includes("assetList")) {
        let assetData = data.assetList;
        if (assetData.length === 0) {
          this.showError("propertyMaintenance.errorSelectAsset");
        } else {
          this.assetIds = [];
          assetData.forEach(e => {
            this.assetIds.push(e.id);
          });
          this.onSaveAssetActivityTracking();
        }
      } else {
        this.assetIds = this.assetSelectIds;
        this.maintenanceTypeValue = data.maintenanceType;
        this.titleData = data.title;
        this.priceData = data.price
        this.description = data.description;
        this.onSaveAssetActivityPlan();
      }
      // if (this.isAssetSelectFromTrackingList) {
      //   this.assetIds = this.assetSelectIds
      //   this.onSaveAssetActivityPlan();
      // } else {
      //   if (data.length === 0) {
      //     this.showError("propertyMaintenance.errorSelectAsset");
      //   } else {
      //     this.assetIds = [];
      //     data.forEach(e => {
      //       this.assetIds.push(e.id);
      //     });
      //     this.onSaveAssetActivityTracking();
      //   }
      // }
    },
    onSaveAssetActivityTracking: function() {
      let data = {
        assetIds: this.assetIds
      };
      this.POST_ASSET_LIST_ACTIVITY_TRACKING(data)
        .then(
          function() {
            this.isLoading = false;
            this.$refs.selectMultiplateAssetActivityTrackingModal.onCloseModal();
            this.onSearchActivityTracking(this.paginateData.currentPage);
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
          }.bind(this)
        );
    },
    addAssetActivityTracking: function() {
      this.modalTitle = "propertyMaintenance.assetList";
      this.notiData = ''
      this.isAssetTable = true;
      this.isShowMaintenanceType = false;
      this.isShowTitle = false;
      this.isShowPrice = false
      this.isShowDescription = false;
      this.$refs.selectMultiplateAssetActivityTrackingModal.onSelectAsset();
    },
    getActivityTrackingList: function(page) {
      let filter = {
        params: {
          page: page,
          searchText: this.searchData.searchText,
          nextImplementationDateFromDate: utils.formatSqlUtcDate(this.searchData.fromDate, "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss"),
          nextImplementationDateToDate: utils.formatSqlUtcDate(this.searchData.toDate, "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss")
        }
      };
      this.GET_ACTIVITY_TRACKING_LIST(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onRefreshData: function(data) {
      this.assetSelectIds = []
      this.onSearchActivityTracking(data);
    },
    onPagination: function(data) {
      this.getActivityTrackingList(data);
    },
    onSearchActivityTracking: function(data) {
      this.searchData.searchText = data.searchText;
      this.searchData.fromDate = data.from_date;
      this.searchData.toDate = data.to_date;
      this.getActivityTrackingList(this.paginateData.currentPage);
    },
    onChangeSelectAllCheckBox: function(checkboxValue) {
      this.assetSelectIds = [];
      this.items.filter(x => {
        if (
          checkboxValue &&
          this.assetSelectIds.includes(x.assetId) === false
        ) {
          this.assetSelectIds.push(x.assetId);
        }
        return (x.isSelect = checkboxValue);
      });
    },
    onSelectAsset: function(item, checkboxValue) {
      if (
        checkboxValue &&
        this.assetSelectIds.includes(item.assetId) === false
      ) {
        this.assetSelectIds.push(item.assetId);
      } else {
        let index = this.assetSelectIds.findIndex(x => x === item.assetId);
        if (index !== -1) {
          this.assetSelectIds.splice(index, 1);
        }
      }
      if (this.assetSelectIds.length === this.items.length && this.items.length > 0) {
        this.selectAllCheckBox = true;
      } else {
        this.selectAllCheckBox = false;
      }
    },
    //
    onShowConfirmAddActivityPlanAssetList: function() {
      if (this.assetSelectIds.length === 0) {
        this.showError("propertyMaintenance.errorSelectAsset");
      } else {
        //
        this.modalTitle = "propertyMaintenance.addNewDevicePlan";
        this.notiData = this.$t(
          "propertyMaintenance.addAssetActivityPlan.body",
          { 0: this.assetSelectIds.length }
        );
        this.isAssetTable = false;
        this.isShowMaintenanceType = true;
        this.isShowTitle = true;
        this.isShowPrice = true;
        this.isShowDescription = true;
        this.$refs.selectMultiplateAssetActivityTrackingModal.onSelectAsset();
      }
    },
    onSaveAssetActivityPlan: function() {
      let data = {
        assetIds: this.assetIds,
        maintenanceType: this.maintenanceTypeValue,
        title: this.titleData,
        price: this.priceData,
        description: this.description
      };
      this.POST_ASSET_LIST_ACTIVITY_PLAN(data)
        .then(
          function() {
            this.isLoading = false;
            // set data null
            this.assetIds = [];
            // this.assetSelectIds = [];
            this.$refs.selectMultiplateAssetActivityTrackingModal.onCloseModal();
            // this.getActivityTrackingList(this.paginateData.currentPage)
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
          }.bind(this)
        );
    },
    //
    closeModal: function() {
      this.isModalVisible = false;
    },
    onRemoveActivityTrackingList: function() {
      if (this.assetSelectIds.length === 0) {
        this.showError("propertyMaintenance.errorSelectAsset");
      } else {
        this.objModal[0].body = this.$t(
          "propertyMaintenance.removeAssetTrackingList.body",
          { 0: this.assetSelectIds.length }
        );
        this.isModalVisible = true;
      }
    },
    onConfirm: function() {
      let data = {
        assetIdList: this.assetSelectIds
      };
      this.REMOVE_ASSET_LIST_ACTIVITY_TRACKING(data)
        .then(
          function() {
            this.isLoading = false;
            // set data null
            this.assetSelectIds = [];
            this.isModalVisible = false
            this.getActivityTrackingList(this.paginateData.currentPage)
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onShowAssetDetail: function(data) {
      this.assetInActivityDetailModalTitle = "propertyMaintenance.assetDetail"
      this.$refs.assetInActivityDetailModal.onGetData(data.assetId)
    },
    exportExcel: function() {
      let filter = {
        params: {
          searchText: this.searchData.searchText,
          nextImplementationDateFromDate: utils.formatSqlUtcDate(this.searchData.fromDate, "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss"),
          nextImplementationDateToDate: utils.formatSqlUtcDate(this.searchData.toDate, "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss")
        }
      };
      this.GET_ACTIVITY_TRACKING_LIST(filter)
        .then(
          async function(res) {
            this.isLoading = false;
            let dataList = this.getDataExcelJson(
              this.exportExcelData.headerList,
              res
            );
            await this.createExcelFile(dataList);
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
          }.bind(this)
        );
    },
    getDataExcelJson: function(headerList, dataList) {
      let resultList = [];
      let assetCodeHeader = headerList[0];
      let assetNameHeader = headerList[1];

      dataList.forEach(data => {
        let item = {
          [this.$t(assetCodeHeader)]: data.code,
          [this.$t(assetNameHeader)]: data.name
        }
        resultList.push(item)
      });
      return resultList;
    },
    createExcelFile: function(jsonData) {
      let data_list = [];

      data_list = jsonData;
      // export json to Worksheet of Excel
      // only array possible
      var assetFile = XLSX.utils.json_to_sheet(data_list);
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, assetFile, "activityTracking"); // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')

      // export Excel file
      XLSX.writeFile(wb, "ActivityTracking.xlsx"); // name of the file is 'book.xlsx'
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "POST_ASSET_LIST_ACTIVITY_TRACKING",
      "REMOVE_ASSET_LIST_ACTIVITY_TRACKING",
      "GET_ACTIVITY_TRACKING_LIST",
      "POST_ASSET_LIST_ACTIVITY_PLAN"
    ])
  },
  mounted() {
    this.getActivityTrackingList(this.paginateData.currentPage)
  }
};
</script>
<style lang="scss" scoped>
.table-responsive :deep(.b-table .asset-is-deleted) {
  background: #f5c6cb;
}
.detail-activity {
  color: #006ad4;
}
.hover-action {
  cursor: pointer;
}
.hover-action:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/Property/ActivityTrackingList.vue